import "./UwPolicyRead.scss";
import { TbCertificate } from "react-icons/tb";
import BrokenImageOutlinedIcon from '@mui/icons-material/BrokenImageOutlined';
import { BsCalendar2Date, BsCalendar4Range } from "react-icons/bs";
import moment from "moment";
import { useTranslation } from "react-i18next";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import UwPolicyInstallments from "../uwPolicyInstallments/UwPolicyInstallments.jsx";
import UwPolicyRisk from "../uwPolicyRisk/UwPolicyRisk.jsx";
import { useRef, useState } from "react";
import UwPolicyCond from "../uwPolicyCond/UwPolicyCond.jsx";
import { CiImageOn } from "react-icons/ci";
import { PiHashBold, PiPackageDuotone } from "react-icons/pi";
import { GrTransaction } from "react-icons/gr";
import { RiBuilding2Fill } from "react-icons/ri";
import Taccount from "../../../components/taccount/Taccount.jsx";
import { MdEmail, MdOutlineNumbers, MdPhone, MdSource } from "react-icons/md";
import { LuArrowRightFromLine } from "react-icons/lu";
import { AiOutlineNumber } from "react-icons/ai";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar.jsx";


const UwPolicyRead = ({ quoteData, currentTheme, currentUser }) => {
    const { t } = useTranslation();
    const [policyRiskKey, setPolicyRiskKey] = useState(0);
    const policyRiskRef = useRef(null);
    const policyExcessRef = useRef(null);
    const policyCondRef = useRef(null);

    return (
        <div className="uw-policy-read">
            <div className={`policy-read-wrapper ${currentTheme}`}>
                <div className="policy-read-content">
                    {/* <div style={{ display: "flex", width: "100%", flexDirection: "row", marginBottom: "10px", gap: "10px", alignItems: "center", justifyContent: "space-between" }}>
                        {["agent", "broker"].includes(currentUser?.token_org_type) &&
                            <div className="document-title">
                                <span>{t('riskNoteNo')}</span>
                                <span>{quoteData?.pl_risk_note_no}</span>
                            </div>}
                        {["insurance"].includes(currentUser?.token_org_type) &&
                            <div className="document-title">
                                <span className="normal-title">{quoteData?.pl_no}</span>
                            </div>}
                        <hr className="separator-v" />
                        <h1 className="sub-title">{quoteData?.end_name_xx}</h1>
                        <hr className="separator-v" />
                        <h1 className="sub-title">{moment(quoteData?.pl_gl_date).format("DD-MMM-YYYY")}</h1>
                    </div> */}
                    <div className="approved-doc">
                        {["agent", "broker"].includes(currentUser?.token_org_type) && <span className="sub-title" style={{ display: "flex", gap: "5px", justifyContent: "center" }}><PiHashBold className="prompt-icon" />{quoteData?.pl_risk_note_no}</span>}
                        {["insurance"].includes(currentUser?.token_org_type) && <span className="sub-title" style={{ display: "flex", gap: "5px", justifyContent: "center" }}><PiHashBold className="prompt-icon" />{quoteData?.pl_no}</span>}
                        <span className="sub-title" style={{ display: "flex", gap: "5px", justifyContent: "center" }}><MdSource className="prompt-icon" />{quoteData?.end_name_xx}</span>
                        <span className="sub-title" style={{ display: "flex", gap: "5px", justifyContent: "center" }}><BsCalendar2Date className="prompt-icon" /> {`${moment(quoteData?.pl_gl_date).format("DD-MMM-YYYY")}`}</span>
                    </div>
                    {/* <div className="line-wrapper"> <span /> </div> */}
                    <div className="header-details">
                        <div className="header-details-left">
                            <span style={{ display: "flex", width: "100%", marginBottom: "10px", paddingRight: "10px", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                <h1 className="main-title">{t('insured')}</h1>
                                {quoteData?.insured_details_xx?.ent_photo_url &&
                                    <div className="entity-details-left">
                                        {quoteData?.insured_details_xx?.ent_photo_url ?
                                            <img src={quoteData?.insured_details_xx?.ent_photo_url} alt="" className="entity-img" />
                                            :
                                            <InitialsAvatar
                                                name={quoteData?.insured_details_xx?.ent_name}
                                                size={40}
                                                currentTheme={currentTheme}
                                            />}
                                    </div>}
                            </span>
                            {/* <hr className="separator-h" /> */}
                            <div className="entity-details-wrapper">
                                <div className="entity-details-right">
                                    <h1 className="main-title two-lines">  {quoteData?.insured_details_xx?.ent_name} </h1>
                                    <div style={{ display: "flex", flexDirection: quoteData?.carrier_details_xx?.ent_name ? "column" : "row" }}>
                                        <div className="icon-value-row">
                                            <MdEmail className="icon" />
                                            <h1 className="sub-title">{`${t('email').toUpperCase()}: ${quoteData?.insured_details_xx?.ent_email || ""}`}</h1>
                                        </div>
                                        <div className="icon-value-row">
                                            <MdPhone className="icon" />
                                            <h1 className="sub-title">{`${t('phone').toUpperCase()}: ${quoteData?.insured_details_xx?.ent_phone_no || ""}`}</h1>
                                        </div>
                                        <div className="icon-value-row">
                                            <TbCertificate className="icon" />
                                            <h1 className="sub-title">{`${t('type').toUpperCase()}: ${quoteData?.insured_details_xx?.ent_type || ""}`}</h1>
                                        </div>
                                        <div className="icon-value-row">
                                            <MdOutlineNumbers className="icon" />
                                            <h1 className="sub-title">{quoteData?.insured_details_xx?.ent_code}</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {quoteData?.carrier_details_xx?.ent_name && <span className="vertical-line" />}
                        {quoteData?.carrier_details_xx?.ent_name &&
                            <div className="header-details-right">
                                <span style={{ display: "flex", width: "100%", marginBottom: "10px", paddingRight: "10px", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                    <h1 className="main-title">
                                        {(() => {
                                            switch (currentUser?.token_org_type) {
                                                case "agent":
                                                case "broker":
                                                    return t('carrier');
                                                case "insurance":
                                                    return t('intermediary');
                                                default:
                                                    return t('partner');
                                            }
                                        })()}
                                    </h1>
                                    {quoteData?.carrier_details_xx?.ent_photo_url ?
                                        <img src={quoteData?.carrier_details_xx?.ent_photo_url} alt="" className="entity-img" />
                                        :
                                        <InitialsAvatar
                                            name={quoteData?.carrier_details_xx?.ent_name}
                                            size={40}
                                            currentTheme={currentTheme}
                                        />
                                    }
                                </span>
                                {/* <hr className="separator-h" /> */}
                                <div className="entity-details-wrapper">
                                    <div className="entity-details-right">
                                        <h1 className="main-title two-lines">  {quoteData?.carrier_details_xx?.ent_name} </h1>
                                        <div className="icon-value-row">
                                            <MdEmail className="icon" />
                                            <h1 className="sub-title">{`${t('email').toUpperCase()}: ${quoteData?.carrier_details_xx?.ent_email || ""}`}</h1>
                                        </div>
                                        <div className="icon-value-row">
                                            <MdPhone className="icon" />
                                            <h1 className="sub-title">{`${t('phone').toUpperCase()}: ${quoteData?.carrier_details_xx?.ent_phone_no || ""}`}</h1>
                                        </div>
                                        <div className="icon-value-row">
                                            <TbCertificate className="icon" />
                                            <h1 className="sub-title">{`${t('type').toUpperCase()}: ${quoteData?.carrier_details_xx?.ent_type || ""}`}</h1>
                                        </div>
                                        <div className="icon-value-row">
                                            <MdOutlineNumbers className="icon" />
                                            <h1 className="sub-title">{quoteData?.carrier_details_xx?.ent_code}</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </div>
                    <ExpandableComponent
                        title={t('policyInformation').toUpperCase()}
                        subtitle={<h1 className={`main-title status ${quoteData?.pl_status?.replace(" ", "")}`} style={{ fontSize: "16px" }}>{quoteData?.end_internal_code_xx === "000" ? t('newBusiness') : t('endorsement')}</h1>}
                        defaultExpanded={true}
                    >
                        <div className="two-columns-wrapper">
                            <div className="two-columns-left">
                                {["insurance"].includes(currentUser?.token_org_type) &&
                                    <div className="icon-value-row">
                                        <LuArrowRightFromLine className="icon" />  <h1 className="sub-title">{quoteData?.pl_channel}</h1>
                                    </div>}
                                {["agent", "broker"].includes(currentUser?.token_org_type) &&
                                    <div className="icon-value-row">
                                        <AiOutlineNumber className="icon" />
                                        <h1 className="sub-title">{`${t('policyNo').toUpperCase()}: ${quoteData?.pl_no}`}</h1>
                                    </div>}
                                <div className="icon-value-row">
                                    <PiPackageDuotone className="icon" />
                                    <h1 className="sub-title">{`${t('product').toUpperCase()}: ${quoteData?.product_name_xx}`}</h1>
                                </div>
                                <div className="icon-value-row">
                                    <GrTransaction className="icon" />
                                    <h1 className="sub-title">{`${t('transaction').toUpperCase()}: ${quoteData?.end_name_xx}`}</h1>
                                </div></div>
                            <div className="two-columns-right">
                                <div className="icon-value-row">
                                    <BsCalendar4Range className="icon" />
                                    <h1 className="sub-title">{`${t('period').toUpperCase()}: ${quoteData?.formatted_period_xx} - [${quoteData?.difference_in_days} DAYS]`}</h1>
                                </div>
                                <div className="icon-value-row">
                                    <RiBuilding2Fill className="icon" />
                                    <h1 className="sub-title">{`${t('issuingBranch').toUpperCase()}: ${quoteData?.bizunit_name_xx}`}</h1>
                                </div>
                                <div className="icon-value-row">
                                    {quoteData?.updated_by_photo_url_xx ?
                                        <img src={quoteData?.updated_by_photo_url_xx} alt="" className="avatar" />
                                        :
                                        <BrokenImageOutlinedIcon style={{ width: "20px", height: "20px" }} />}
                                    <h1 className="sub-title">{`${t('underwriter').toUpperCase()}: ${quoteData?.updated_by_name_xx}`}</h1>
                                </div>
                            </div>
                        </div>
                    </ExpandableComponent>

                    {/* {quoteData?.pl_claim_basis?.length > 0 && <div className="line-wrapper"> <span /> </div>} */}
                    {quoteData?.pl_claim_basis?.length > 0 &&
                        <ExpandableComponent
                            title={t('additionalInformation').toUpperCase()}
                            subtitle={""}
                            defaultExpanded={true}
                        >
                            <span className="sub-title">{`${t('underwriterRemarks').toUpperCase()}: ${quoteData?.pl_remarks} ${t('unspecified')}`}</span>
                            <hr className="separator-h" />
                            <span className="sub-title">{`${t('basisOfClaimSettlement').toUpperCase()} ${quoteData?.pl_claim_basis?.length === 0 ? t('notSpecified').toUpperCase() : ""}`}</span>
                            <div className="limits-and-benefits">
                                {quoteData?.pl_claim_basis?.length > 0 && (
                                    <div>
                                        {quoteData?.pl_claim_basis?.map((row, index) => (
                                            <div key={row._id}>
                                                <div className="single-row">
                                                    <span
                                                        style={{ width: "20px", alignItems: "center" }}
                                                    >
                                                        {index + 1}.
                                                    </span>
                                                    <span
                                                        style={{
                                                            fontWeight: "500",
                                                            fontSize: "16px",
                                                        }}
                                                    >{row?.basis_text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>


                            <hr className="separator-h" />
                            <span className="sub-title">{`${t('specialNotes').toUpperCase()} ${quoteData?.pl_claim_basis?.length === 0 ? t('notSpecified').toUpperCase() : ""}`}</span>
                            <div className="limits-and-benefits">
                                {quoteData?.pl_claim_basis?.length > 0 && (
                                    <div>
                                        {quoteData?.pl_claim_basis?.map((row, index) => (
                                            <div key={row._id}>
                                                <div className="single-row">
                                                    <span
                                                        style={{ width: "20px", alignItems: "center" }}
                                                    >
                                                        {index + 1}.
                                                    </span>
                                                    <span
                                                        style={{
                                                            fontWeight: "500",
                                                            fontSize: "16px",
                                                        }}
                                                    >{row?.basis_text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                        </ExpandableComponent>}
                    {/* <div className="line-wrapper"> <span /> </div> */}
                    <ExpandableComponent
                        title={t('riskAndCoverage').toUpperCase()}
                        subtitle={""}
                        onSubtitleClick={() => { }}
                        defaultExpanded={true}
                    >
                        <UwPolicyRisk
                            key={policyRiskKey}
                            ref={policyRiskRef}
                            quoteData={quoteData}
                            refreshQuote={""}
                            profileLimitValues={[]}
                            showTitle={false}
                        />
                    </ExpandableComponent>
                    {/* <div className="line-wrapper"> <span /> </div> */}
                    <ExpandableComponent
                        title={t('premiumInstallments').toUpperCase()}
                        subtitle={""}
                        onSubtitleClick={() => { }}
                        defaultExpanded={true}
                    >
                        <UwPolicyInstallments key={quoteData?.fmt_policy_fc_prem} policyDocid={quoteData._id} policyFcPremium={quoteData?.total_fc_premium} plCurCode={quoteData?.pl_cur_code} installmentConfirmed={quoteData?.pl_inst_confirmed} />
                    </ExpandableComponent>
                    {/* {quoteData?.project_limit_yn_xx === "Y" && <div className="line-wrapper"> <span /> </div>} */}
                    {quoteData?.project_limit_yn_xx === "Y" &&
                        <ExpandableComponent
                            title={t('limitsOfLiability').toUpperCase()}
                            subtitle={""}
                            onSubtitleClick={() => { }}
                            defaultExpanded={true}
                        >
                            <div className="limits-and-benefits">
                                {quoteData?.pl_limits?.length > 0 && (
                                    <div>
                                        {quoteData?.pl_limits?.map((row, index) => (
                                            <div key={row._id}>
                                                <div className="single-row">
                                                    <span
                                                        style={{
                                                            alignContent: "flex-start",
                                                        }}
                                                    >
                                                        {index + 1}.
                                                    </span>
                                                    <span
                                                        style={{
                                                            fontWeight: "500",
                                                            fontSize: "16px",
                                                        }}
                                                    >{`${row?.limit_text} ${t('limitOf').toLocaleLowerCase()} ${row?.limit_amount}`}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </ExpandableComponent>}
                    {/* {quoteData?.project_benefit_yn_xx === "Y" && <div className="line-wrapper"> <span /> </div>} */}
                    {quoteData?.project_benefit_yn_xx === "Y" &&
                        <ExpandableComponent
                            title={t('applicableBenefits').toUpperCase()}
                            subtitle={""}
                            onSubtitleClick={() => { }}
                            bgColor="#fff"
                            defaultExpanded={true}
                        >
                            <div className="limits-and-benefits">
                                {quoteData?.pl_benefits?.length > 0 && (
                                    <div>
                                        {quoteData?.pl_benefits?.map((row, index) => (
                                            <div key={row._id}>
                                                <div className="single-row">
                                                    <span
                                                        style={{
                                                            alignContent: "flex-start",
                                                        }}
                                                    >
                                                        {index + 1}.
                                                    </span>
                                                    <span
                                                        style={{
                                                            fontWeight: "500",
                                                            fontSize: "16px",
                                                        }}
                                                    >{`${row?.benefit_text} ${t('limitOf').toLocaleLowerCase()} ${row?.benefit_amount}`}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </ExpandableComponent>}
                    {["insurance"].includes(currentUser?.token_org_type) && <Taccount key={quoteData?.fmt_policy_fc_prem} originalDocId={quoteData._id} originalDocno={quoteData?.pl_no} originalDocType={quoteData?.pl_type} endorsementIndex={quoteData?.pl_end_index} />}
                    {/* <div className="line-wrapper"> <span /> </div> */}
                    <ExpandableComponent
                        title={t('wordings').toUpperCase()}
                        subtitle={""}
                        onSubtitleClick={() => { }}
                        defaultExpanded={quoteData?.policy_conditions?.length > 0}
                    >
                        <UwPolicyCond
                            quoteData={quoteData}
                            refreshQuote={""}
                            ref={policyCondRef}
                            profileLimitValues={[]}
                            showTitle={false}
                        />
                    </ExpandableComponent>
                </div>
            </div>
        </div>
    )
}

export default UwPolicyRead;